import React from 'react';

/**
 * DropdownField — full-width select with large touch target.
 * @param {string}   label       - Field label
 * @param {string[]} options     - Array of option strings
 * @param {string}   value       - Current value
 * @param {function} onChange    - Called with new value string
 * @param {boolean}  required    - Show required star
 * @param {boolean}  hasError    - Show error state
 * @param {string}   errorMsg    - Error message text
 * @param {string}   placeholder - Placeholder option text
 */
function DropdownField({
  label,
  options,
  value,
  onChange,
  required,
  hasError,
  errorMsg,
  placeholder = 'Select…',
}) {
  return (
    <div className="field-group">
      {label && (
        <label className="field-label">
          {label}
          {required && <span className="required-star">*</span>}
        </label>
      )}
      <select
        className={`select-input${hasError ? ' has-error' : ''}`}
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        aria-required={required}
        aria-invalid={hasError}
      >
        <option value="" disabled>
          {placeholder}
        </option>
        {options.map((opt) => (
          <option key={opt} value={opt}>
            {opt}
          </option>
        ))}
      </select>
      {hasError && errorMsg && (
        <p className="error-message">{errorMsg}</p>
      )}
    </div>
  );
}

export default DropdownField;
